import { createContext } from 'react';
export var PortalContext = createContext({
    children: [],
});
